var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTower = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M15 7.726c-2.426 0-4.514-1.523-5.46-3.712A6.616 6.616 0 0 0 9 6.644c0 3.5 2.686 6.34 6 6.34s6-2.84 6-6.34a6.616 6.616 0 0 0-.54-2.63c-.946 2.19-3.034 3.712-5.46 3.712Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M13.875 5.059c0 1.136.157 2.058 1.125 2.058 1.125 0 1.125-.922 1.125-2.058C16.125 3.922 15 3 15 3s-1.125.922-1.125 2.059ZM18.215 12.983c-.97.598-2.08.95-3.228 1.023a6.995 6.995 0 0 1-3.227-1.023c.65 3.873-.244 10.655-1.184 12.95.197.615 1.676 1.067 2.421 1.067h3.98c.745 0 2.225-.452 2.422-1.066-.94-2.296-1.835-9.078-1.184-12.95Z"
})));
export default SvgTower;